import axiosInstance from "./AxiosInstance";

// Flag to toggle between real API and dummy data
const USE_DUMMY_DATA = false;

/**
 * Example API Response Format for all endpoints:
 * {
 *   status: "success" | "error",
 *   message: string,
 *   data: <endpoint specific data>
 * }
 */


export const fetchLeadAppointments = (leadId, patientId) => {
  console.log("fetchLeadAppointments called with:", { leadId, patientId });
  return axiosInstance.post("/lead/appointmentList", { lead_id: leadId, patient_id: patientId});
};


// Dummy data generator functions
const generateDummyAppointments = (leadId) => {
  const today = new Date();
  const appointments = [];

  // Generate some past appointments
  for (let i = -5; i <= 5; i++) {
    const date = new Date(today);
    date.setDate(date.getDate() + i);

    // Skip weekends
    if (date.getDay() === 0 || date.getDay() === 6) continue;

    // Morning appointment
    if (Math.random() > 0.5) {
      appointments.push({
        id: `app_${i}_morning`,
        leadId: leadId,
        patientName: "John Doe",
        doctorId: "doc_123",
        doctorName: "Dr. Smith",
        date: date.toISOString().split("T")[0],
        startTime: "10:00 AM",
        endTime: "11:00 AM",
        status: date < today ? "completed" : "booked",
        type: "consultation",
        notes: "Regular checkup",
        createdAt: new Date(date.getTime() - 86400000).toISOString(), // 1 day before appointment
        updatedAt: new Date(date.getTime() - 86400000).toISOString(),
        cancelledAt: null,
        cancellationReason: null,
        department: "General Medicine",
        location: "Main Clinic",
        fee: 500,
        isPaid: date < today,
        paymentStatus: date < today ? "paid" : "pending",
        paymentMethod: date < today ? "card" : null,
      });
    }

    // Evening appointment
    if (Math.random() > 0.5) {
      appointments.push({
        id: `app_${i}_evening`,
        leadId: leadId,
        patientName: "Jane Smith",
        doctorId: "doc_456",
        doctorName: "Dr. Johnson",
        date: date.toISOString().split("T")[0],
        startTime: "04:00 PM",
        endTime: "05:00 PM",
        status: date < today ? "completed" : "booked",
        type: "follow-up",
        notes: "Follow-up consultation",
        createdAt: new Date(date.getTime() - 86400000).toISOString(),
        updatedAt: new Date(date.getTime() - 86400000).toISOString(),
        cancelledAt: null,
        cancellationReason: null,
        department: "Cardiology",
        location: "Specialty Clinic",
        fee: 800,
        isPaid: date < today,
        paymentStatus: date < today ? "paid" : "pending",
        paymentMethod: date < today ? "cash" : null,
      });
    }
  }

  return appointments;
};

const checkDummySlotAvailability = (date) => {
  // Convert date string to Date object
  const appointmentDate = new Date(date);

  // Don't allow appointments on weekends
  if (appointmentDate.getDay() === 0 || appointmentDate.getDay() === 6) {
    return {
      available: false,
      reason: "Weekend slots are not available",
      nextAvailable: null,
    };
  }

  // Random availability but weighted towards being available (70% chance)
  const isAvailable = Math.random() > 0.3;

  return {
    available: isAvailable,
    reason: isAvailable ? null : "Slot already booked",
    nextAvailable: isAvailable
      ? null
      : {
          date: date,
          slots: ["11:00 AM - 12:00 PM", "02:00 PM - 03:00 PM"],
        },
  };
};

const generateDummyTimeSlots = () => {
  const slots = [];
  const startHour = 9;
  const endHour = 20;

  for (let hour = startHour; hour < endHour; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const startTime = formatTime(hour, minute);
      const endTime = formatTime(
        hour + (minute === 30 ? 1 : 0),
        minute === 30 ? 0 : 30
      );
      slots.push({
        time_slot: `${startTime} to ${endTime}`,
        is_available: Math.random() > 0.3,
      });
    }
  }
  return slots;
};

const formatTime = (hour, minute) => {
  const period = hour >= 12 ? "PM" : "AM";
  const displayHour = hour > 12 ? hour - 12 : hour;
  return `${String(displayHour).padStart(2, "0")}:${String(minute).padStart(
    2,
    "0"
  )} ${period}`;
};

export function fetchAvailableTimeSlots(params) {
  if (USE_DUMMY_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: "success",
          message: "Available Time Slot list",
          data: generateDummyTimeSlots(),
        });
      }, 500);
    });
  }

  // Determine the endpoint based on appointment type
  const endpoint =
    params.appointmentType === "reschedule"
      ? "/lead/availableTimeSlot"
      : "/lead/availableTimeSlot";

  // Prepare request data based on appointment type
  const requestData = {
    token: localStorage.getItem("token"),
    admin_id: localStorage.getItem("admin_id"),
    doctor_id: params.doctorId,
    start_date: params.startDate,
    end_date: params.endDate,
  };

  // Add lead_id or patient_id based on appointment type
  if (params.appointmentType === "reschedule") {
    requestData.patient_id = params.patientId;
  } else {
    requestData.lead_id = params.leadId;
  }

  return axiosInstance.post(endpoint, requestData);
}

// export function bookAppointment(appointmentData) {
//   if (USE_DUMMY_DATA) {
//     return new Promise((resolve) => {
//       setTimeout(() => {
//         resolve({
//           status: "success",
//           message: "Lead Appointment added successfully",
//           data: {
//             // appointment_id: String(Date.now()),
//             lead_id: appointmentData.leadId,
//             // doctor_id: appointmentData.doctorId,
//             token_no: "0",
//             date: appointmentData.date,
//             // time_slot: appointmentData.timeSlot,
//             appointment_status: "Waiting",
//             is_payment: "No",
//             created_at: new Date()
//               .toISOString()
//               .replace("T", " ")
//               .split(".")[0],
//             updated_at: new Date()
//               .toISOString()
//               .replace("T", " ")
//               .split(".")[0],
//           },
//         });
//       }, 500);
//     });
//   }
//   return axiosInstance.post("/lead/addAppointment", {
//     token: localStorage.getItem("token"),
//     admin_id: localStorage.getItem("admin_id"),
//     lead_id: appointmentData.leadId,
//     // doctor_id: appointmentData.doctorId,
//     appointment_date: appointmentData.date,
//     // time_slot: appointmentData.timeSlot,
//     appointment_type: appointmentData.appointmentType || "",
//     patient_id: appointmentData.patientId || null,
//     mode: appointmentData.mode ,
//     branch_id: appointmentData.branchId,
//   });
// }

export function bookAppointment(appointmentData) {
  return axiosInstance.post("/lead/addAppointment", {
    token: localStorage.getItem("token"),
    admin_id: localStorage.getItem("admin_id"),
    lead_id: appointmentData.leadId,
    patient_id: appointmentData.patientId,
    appointment_date: appointmentData.date,
    appointment_type: appointmentData.appointmentType,
    mode: appointmentData.mode,
    branch_id: appointmentData.branchId,
    // consultation_fees: appointmentData.consultation_fees,
    telecaller_note: appointmentData.telecaller_note,
    appointment_camp_reg: appointmentData.appointment_camp_reg,
  });
}


export function fetchAppointments(leadId) {
  if (USE_DUMMY_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: "success",
          message: "Appointments fetched successfully",
          data: generateDummyAppointments(leadId),
          pagination: {
            total: 10,
            perPage: 10,
            currentPage: 1,
            lastPage: 1,
            from: 1,
            to: 10,
          },
        });
      }, 500);
    });
  }
  return axiosInstance.get(`/appointments/${leadId}`);
}

export function cancelAppointment(appointmentId) {
  if (USE_DUMMY_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: "success",
          message: "Appointment cancelled successfully",
          data: {
            id: appointmentId,
            status: "cancelled",
            cancelledAt: new Date().toISOString(),
            cancellationReason: "Patient request",
            updatedAt: new Date().toISOString(),
          },
        });
      }, 500);
    });
  }
  return axiosInstance.post("/appointments/cancel", { appointmentId });
}

export function checkSlotAvailability(date, timeSlot) {
  if (USE_DUMMY_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: "success",
          message: "Slot availability checked successfully",
          data: checkDummySlotAvailability(date),
        });
      }, 200);
    });
  }
  return axiosInstance.post("/appointments/check-slot", { date, timeSlot });
}

// Helper function to check if an appointment exists in lead details
export function getExistingAppointment(leadDetails) {
  return leadDetails?.AppointmentDetails || null;
}

// Helper function to format appointment data for display
export function formatAppointmentData(appointment) {
  return {
    id: appointment.appointment_id,
    leadId: appointment.lead_id,
    doctorId: appointment.doctor_id,
    date: appointment.date,
    timeSlot: appointment.time_slot,
    status: appointment.appointment_status,
    isPaid: appointment.is_payment === "Yes",
    tokenNo: appointment.token_no,
    createdAt: appointment.created_at,
    updatedAt: appointment.updated_at,
  };
}

export const fetchBookedSlots = async ({ doctorId, startDate, endDate }) => {
  try {
    const response = await axiosInstance.get(`/lead/bookedSlots`, {
      params: {
        doctorId,
        startDate,
        endDate,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching booked slots:", error);
    throw error;
  }
};

export function collectAppointmentPayment(paymentData) {
  return axiosInstance.post("/lead/collectPayment", {
    token: localStorage.getItem("token"),
    admin_id: localStorage.getItem("admin_id"),
    lead_id: paymentData.lead_id,
    appointment_id: paymentData.appointment_id,
    amount: paymentData.amount,
    payment_type: paymentData.payment_type,
    payment_for: "APPOINTMENT",
    coupon_code: paymentData.coupon_code || "",
    final_amount: paymentData.final_amount,
    patient_id: paymentData.patient_id || null,
  });
}

export function cancelLeadAppointment(appointmentId) {
  return axiosInstance.post("/lead/appointmentCancel", {
    token: localStorage.getItem("token"),
    admin_id: localStorage.getItem("admin_id"),
    // lead_id: leadId,
    // patient_id: patientId,
    appointment_id: appointmentId,
  });
}

// Helper function to determine if an appointment belongs to the current user
export function isCurrentUserAppointment(
  appointment,
  currentPatientId,
  currentLeadId
) {
  if (!appointment || !appointment.appointmentDetails) return false;

  const appointmentDetails = appointment.appointmentDetails;

  // Check if it's the current patient's appointment
  if (currentPatientId && appointmentDetails.patient_id) {
    return String(appointmentDetails.patient_id) === String(currentPatientId);
  }

  // Check if it's the current lead's appointment
  if (currentLeadId && appointmentDetails.lead_id) {
    return String(appointmentDetails.lead_id) === String(currentLeadId);
  }

  return false;
}

// Helper function to get slot color class based on appointment status
export function getSlotColorClass(slot, currentPatientId, currentLeadId) {
  if (slot.is_available === "Yes") {
    return "available";
  }

  if (slot.appointmentDetails) {
    const appointment = slot.appointmentDetails;
    const isCurrentUser =
      (currentPatientId &&
        String(appointment.patient_id) === String(currentPatientId)) ||
      (currentLeadId && String(appointment.lead_id) === String(currentLeadId));

    if (isCurrentUser) {
      return appointment.is_payment === "Yes" ? "confirmed" : "booked";
    } else {
      return "booked-other";
    }
  }

  return "unavailable";
}

// Helper function to get slot status text
export function getSlotStatusText(slot, currentPatientId, currentLeadId) {
  if (slot.is_available === "Yes") {
    return "Available";
  }

  if (slot.appointmentDetails) {
    const appointment = slot.appointmentDetails;
    const isCurrentUser =
      (currentPatientId &&
        String(appointment.patient_id) === String(currentPatientId)) ||
      (currentLeadId && String(appointment.lead_id) === String(currentLeadId));

    if (isCurrentUser) {
      return appointment.is_payment === "Yes"
        ? "Confirmed"
        : "Your Appointment";
    } else {
      return "Booked";
    }
  }

  return "Unavailable";
}

// Helper function to format time slots response for the common calendar
export function formatTimeSlotsResponse(
  response,
  currentPatientId,
  currentLeadId
) {
  if (!response || !response.data || !Array.isArray(response.data)) {
    return [];
  }

  return response.data.map((dayData) => ({
    ...dayData,
    slots: dayData.slots
      ? dayData.slots.map((slot) => ({
          ...slot,
          colorClass: getSlotColorClass(slot, currentPatientId, currentLeadId),
          statusText: getSlotStatusText(slot, currentPatientId, currentLeadId),
          isClickable:
            slot.is_available === "Yes" ||
            isCurrentUserAppointment(
              { appointmentDetails: slot.appointmentDetails },
              currentPatientId,
              currentLeadId
            ),
        }))
      : [],
  }));
}

// Helper function to get week dates for calendar navigation
export function getWeekDates(startDate) {
  const dates = [];
  const start = new Date(startDate);

  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    dates.push(date);
  }
  return dates;
}

// Helper function to get Monday of a week
export function getWeekStart(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}

// Helper function to format date for API calls
export function formatDateForAPI(date) {
  return date.toISOString().split("T")[0];
}

// Helper function to format date for display
export function formatDateForDisplay(date) {
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

// Enhanced function to fetch available time slots with better error handling
export async function fetchAvailableTimeSlotsEnhanced(params) {
  try {
    const response = await fetchAvailableTimeSlots(params);

    if (response.data?.status === "success") {
      return {
        success: true,
        data: formatTimeSlotsResponse(
          response.data,
          params.currentPatientId,
          params.currentLeadId
        ),
        message: response.data.message || "Time slots fetched successfully",
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.data?.message || "Failed to fetch time slots",
      };
    }
  } catch (error) {
    console.error("Error fetching time slots:", error);
    return {
      success: false,
      data: [],
      message: error.message || "Error fetching time slots",
    };
  }
}

// Function to validate appointment data before booking
export function validateAppointmentData(appointmentData) {
  const errors = [];

  if (!appointmentData.doctorId) {
    errors.push("Doctor ID is required");
  }

  if (!appointmentData.date) {
    errors.push("Appointment date is required");
  }

  if (!appointmentData.timeSlot) {
    errors.push("Time slot is required");
  }

  if (!appointmentData.leadId && !appointmentData.patientId) {
    errors.push("Either lead ID or patient ID is required");
  }

  return {
    isValid: errors.length === 0,
    errors: errors,
  };
}

export function updateAppointment(appointmentData) {
  if (USE_DUMMY_DATA) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: "success",
          message: "Appointment updated successfully",
          data: {
            appointment_id: appointmentData.appointmentId,
            mode: appointmentData.mode,
            branch_id: appointmentData.branchId,
            updated_at: new Date()
              .toISOString()
              .replace("T", " ")
              .split(".")[0],
          },
        });
      }, 500);
    });
  }

  return axiosInstance.post("/patient/updateAppointment", {
    appointment_id: appointmentData.appointmentId,
    token: localStorage.getItem("token"),
    admin_id: localStorage.getItem("admin_id"),
    branch_id: appointmentData.branchId,
    mode: appointmentData.mode,
  });
}
